module.exports = __webpack_public_path__ + "img/XiaomiRedmiNote11.8276e7c1.png";